<template>
  <div class="create_wrapper product">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("edit") }}</h4>
      </div>
      <main-loader v-if="btnIsLoading"></main-loader>
      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-lg-12 mx-auto">
              <div class="upload_input_wrapper col-lg-4 mx-auto">
                <uplode-image
                  :data_src="data.image"
                  @inputChanged="uplodeImg"
                  placeHolder="الصورة"
                ></uplode-image>
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.alt_image_ar"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (عربي)</label
                >
              </div>
            </div>
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.alt_image_en"
                />
                <label for="name_input" class="form-label"
                  >النص البديل للصورة (إنجليزي)</label
                >
              </div>
            </div>
            <div class="col-lg-4">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.name"
                />
                <label for="name_input" class="form-label">الاسم</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="input_wrapper top_label">
                <input
                  type="url"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model="data.link"
                />
                <label for="name_input" class="form-label">الرابط</label>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="input_wrapper">
                <label for="name_input" class="form-label">
                  اختر تقنية
                </label>
                <multiselect
                  v-model="data.technology"
                  :options="technologies"
                  label="title"
                  track-by="id"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <div class="option__desc d-flex justify-between">
                      <span class="option__title">
                        {{ props.option.title }}
                      </span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Update",

  props: ["id"],

  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.tools.title"),
          disabled: false,
          href: "/tools",
        },
        {
          text: this.$t("breadcrumb.tools.edit"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data To Send
      data: {
        image: null,
        name: null,
        link: null,
        technology: null,
        alt_image_ar: null,
        alt_image_en: null,
      },
      // Technologies
      technologies: [],
    };
  },

  methods: {
    // Uplode Image
    uplodeImg(obj) {
      this.data.image = obj;
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;
      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "أرفق صورة",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.name) {
        this.$iziToast.error({
          timeout: 2000,
          message: "حقل اسم الاداة مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.link) {
        this.$iziToast.error({
          timeout: 2000,
          message: "حقل اللينك مطلوب",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.technology) {
        this.$iziToast.error({
          timeout: 2000,
          message: "اختر تقنية",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      submit_data.append("technology_id", this.data.technology.id);
      submit_data.append("link", this.data.link);
      submit_data.append("title", this.data.name);
      if (this.data.alt_image_ar) {
        submit_data.append(`ar[alt_image]`, this.data.alt_image_ar);
      }
      if (this.data.alt_image_en) {
        submit_data.append(`en[alt_image]`, this.data.alt_image_en);
      }
      submit_data.append("_method", "PUT");
      if (this.data.image.img_file) {
        submit_data.append("image", this.data.image.img_file);
      }
      this.axios({
        method: "POST",
        url: `tool/${this.id}`,
        data: submit_data,
      })
        .then(() => {
          this.$iziToast.success({
            timeout: 2000,
            message: this.$t("editSuccess"),
            position: "bottomRight",
          });
          this.$router.push({ path: "/tools" });
          this.btnIsLoading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },
    // get Technologies
    getTechnologies() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: "technology",
      })
        .then((res) => {
          this.technologies = res.data.data;

          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.loading = false;
        });
    },
    // get Tool Data
    getToolData() {
      this.loading = true;
      this.axios({
        method: "GET",
        url: `tool/${this.id}`,
      })
        .then((res) => {
          this.data = {
            image: res.data.data.image,
            name: res.data.data.title,
            link: res.data.data.link,
            technology: res.data.data.technology,
            alt_image_ar: res.data.data.alt_image_ar,
            alt_image_en: res.data.data.alt_image_en,
            // technology:this.technologies.find((el)=> el.id ==res.data.data.technology.id ),
          };
          this.loading = false;
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/tools" });
          this.loading = false;
        });
    },
  },

  created() {
    this.getTechnologies();
    this.getToolData();
  },
};
</script>

<style lang="scss" scoped>
.repeater_wrapper {
  border: 1px solid #29398c;
  border-radius: 15px;
  padding-block: 20px;

  h3,
  h5 {
    color: #29398c;
  }

  &.disabled {
    cursor: not-allowed;

    h3 {
      color: gray;
      font-size: 25px;
    }

    h4 {
      font-size: 21px;
      color: gray;
    }

    & > * {
      pointer-events: none;
    }
  }
}
</style>
